import { render, staticRenderFns } from "./PromotionEntryView.vue?vue&type=template&id=b8c4fe36&scoped=true"
import script from "./PromotionEntryView.vue?vue&type=script&lang=js"
export * from "./PromotionEntryView.vue?vue&type=script&lang=js"
import style0 from "./PromotionEntryView.vue?vue&type=style&index=0&id=b8c4fe36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c4fe36",
  null
  
)

export default component.exports